// RevenueOverview.js
import { useState, useEffect } from "react";
import { getRevenueOverview } from "../../service/Mainservice";
import Loader from "../../Loader/Loader";
import "./RevenueOverview.css";

// MUI Icons
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import PercentIcon from "@mui/icons-material/Percent";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import BuildIcon from "@mui/icons-material/Build";
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";

// Optional: React ApexCharts for trend visualization
import Chart from "react-apexcharts";

const RevenueOverview = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const [startDate, setStartDate] = useState(
    new Date(new Date().setDate(1)).toISOString().split("T")[0],
  );
  const [endDate, setEndDate] = useState(
    new Date().toISOString().split("T")[0],
  );

  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await getRevenueOverview({ startDate, endDate });
      console.log("Revenue Overview Data:", res.data);
      setData(res.data.data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [startDate, endDate]);

  const metrics = [
    {
      label: "Total Revenue",
      value: data?.totalRevenue,
      color: "#133a34",
      icon: <AttachMoneyIcon />,
    },
    {
      label: "Commission Earned",
      value: data?.commissionEarned,
      color: "#eb6718",
      icon: <PercentIcon />,
    },
    {
      label: "Delivery Fees",
      value: data?.deliveryFeesCollected,
      color: "#3b82f6",
      icon: <LocalShippingIcon />,
    },
    {
      label: "Service Fees",
      value: data?.serviceFeesCollected,
      color: "#8b5cf6",
      icon: <BuildIcon />,
    },
    {
      label: "Refunds Issued",
      value: data?.refundsIssued,
      color: "#ef4444",
      icon: <CurrencyExchangeIcon />,
    },
    {
      label: "Net Profit",
      value: data?.netProfit,
      color: "#10b981",
      icon: <AccountBalanceIcon />,
    },
  ];

  // Example chart config (optional - you can replace with real data)
  const chartOptions = {
    chart: { type: "bar", height: 350, toolbar: { show: false } },
    plotOptions: { bar: { borderRadius: 4, columnWidth: "50%" } },
    dataLabels: { enabled: false },
    xaxis: { categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun"] },
    colors: ["#133a34"],
  };
  const chartSeries = [{ name: "Revenue", data: [30, 40, 35, 50, 49, 60] }];

  return (
    <div className="revenue-overview">
      <div className="filter-row">
        <div className="filter-group">
          <label>Start Date</label>
          <input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
        </div>
        <div className="filter-group">
          <label>End Date</label>
          <input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />
        </div>
        <button className="btn-refresh" onClick={fetchData}>
          Refresh
        </button>
      </div>

      {loading ? (
        <Loader />
      ) : (
        <>
          <div className="metrics-grid">
            {metrics.map((m) => (
              <div
                key={m.label}
                className="metric-card"
                style={{ borderLeftColor: m.color }}
              >
                <div className="metric-icon" style={{ color: m.color }}>
                  {m.icon}
                </div>
                <div className="metric-content">
                  <span className="metric-label">{m.label}</span>
                  <span className="metric-value">
                    ${m.value?.toFixed(2) || "0.00"}
                  </span>
                </div>
              </div>
            ))}
          </div>
          {/* Optional Revenue Trend Chart
          <div className="chart-container">
            <Chart
              options={chartOptions}
              series={chartSeries}
              type="bar"
              height={350}
            />
          </div> */}
        </>
      )}
    </div>
  );
};

export default RevenueOverview;
